import React from 'react';

import { Input, Form, Select, Icon, Radio } from 'antd';

const { TextArea } = Input;
const { Option } = Select;
const RadioGroup = Radio.Group;

const input = (props) => {
  const label = props.label ? props.label.charAt(0).toUpperCase() + props.label.slice(1) : null;
  let inputElement = null;

  switch(props.elementType) {
    case ('input'):
        inputElement = <Input
        // className={inputClasses.join(' ')}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed}
        suffix={props.icon ? 
          <Icon type="user-add" style={{ color: "rgba(0,0,0,.25)" }} />
          : null
        }
        />;
      break;
    case ('textarea'):
      inputElement = <TextArea
        // className={inputClasses.join(' ')}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed}
         />;
      break;
    case ('radio'): 
      inputElement = (
        <RadioGroup
          value={props.value}
          onChange={props.changed}
        >
          {
            props.options.map(option => (
              <Radio value={option.value} key={option.value}>{option.title}</Radio>
            ))
          }
        </RadioGroup>
      );
      break;
    case ('select'):
      inputElement = (
        <Select
          // className={inputClasses.join(' ')}
          value={props.value.id}
          {...props.elementConfig}
          onChange={props.selectChange} >
            {
              props.options.map(option => (
                <Option
                  value={option.id}
                  title={option.title}
                  key={option.id}
                >
                  {option.title}
                </Option>
              ))
            }
        </Select>
      );
      break;
    case ('tags'):
      inputElement = (
        <Select
          // className={inputClasses.join(' ')}
          value={props.value}
          {...props.elementConfig}
          onChange={props.changed} >
            {
              props.options.map(tag => (
                <Option
                  key={tag}
                >
                  {tag}
                </Option>
              ))
            }
        </Select>
      );
      break;
    default:
      inputElement = <Input
        // className={inputClasses.join(' ')}
        {...props.elementConfig}
        value={props.value} />
  }

  let field = (
    <Form.Item label={label}>
      {inputElement}
    </Form.Item>
  );
  if(props.noShown){
    field = null;
  }
  return field
};

export default input;


// WEBPACK FOOTER //
// ./src/components/UI/Input/Input.js